import React from "react";
import { STATUS } from "@/lib/utils-app";

export default function StatusBadge({ status, className = "", testid }) {
  const s = STATUS[status] || { label: status, classes: "bg-zinc-100 text-zinc-700 border-zinc-200" };
  return (
    <span
      data-testid={testid || `status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-sm text-xs font-medium border ${s.classes} ${className}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70" />
      {s.label}
    </span>
  );
}
